import React from 'react';
import PropTypes from 'prop-types';
import CourseCarouselItem from '../CourseCarouselItem';

const LibraryListItems = (props) => (
  <section>
    <h3 className='epsilon'>{props.heading}</h3>
    <ul className='course-card-grid js-inview'>
      {
        props.courses.map((course) => (
          <CourseCarouselItem course={course} key={course.id} />
        ))
      }
    </ul>
  </section>
);

LibraryListItems.propTypes = {
  courses: PropTypes.array,
  heading: PropTypes.string
};

export default LibraryListItems;



// WEBPACK FOOTER //
// ./src/components/LibraryListItems/index.js